import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import {SearchAutoCompleteParam} from '../../common/shared/api/nicolas/params/SearchAutoCompleteParam.interface';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {SearchAutoCompleteVo} from '../../common/shared/api/nicolas/vo/SearchAutoCompleteVo.interface';

/**
 * 검색 자동완성
 *
 * Origin: pageNicolasApi.getSearchAutoComplete
 * API: GET /gateway/api/v1/search/autocomplete
 */
export async function getSearchAutocomplete(
  params: SearchAutoCompleteParam,
  options?: FetcherOptions
): Promise<ApiResultVo & {result: SearchAutoCompleteVo}> {
  const {keyword, size = 10} = params;

  const response = await axiosBffFetch(
    '/api/gateway/api/v1/search/autocomplete',
    {
      method: 'GET',
      params: {keyword, size},
    },
    options
  );

  return response.data;
}
